const UseTestMembers = (access) => {

  const testMembers = [
    {
      name: "Carlota Sulit (test)",
      position: "Physician",
      access: "admin",
      pic:
        "https://images.squarespace-cdn.com/content/v1/5cf0d08d5fc69d000172462a/1599805610146-J0G5GMGFBXVWND4Z71UK/Aleem+Business+Headshot+for+LinkedIn+Profile.jpg",
    },
    {
      name: "Rose Reyes (test)",
      position: "Healthcare VA",
      access: "member",
      pic:
        "https://images.squarespace-cdn.com/content/v1/5cf0d08d5fc69d000172462a/1636100249202-5NY98C6ASRIFFPO9GZTU/Tom+Professional+Business+Headshot.jpg?format=500w",
    },
    {
      name: "Anthony Caedo (test)",
      position: "App Tester",
      access: "guest",
      pic:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGQHnde70uCkEfpS4tBgxuBZGWCSt1ZGBOnA&usqp=CAU",
    },
    {
      name: "Eadgar Pearce (test)",
      position: "Physician",
      access: "admin",
      pic:
        "https://www.bethesdaheadshots.com/wp-content/uploads/2022/05/attorney-professional-headshot-photographer-3.jpg",
    },
    {
      name: "Ulises Van Ankeren (test)",
      position: "Healthcare VA",
      access: "member",
      pic:
        "https://www.bethesdaheadshots.com/wp-content/uploads/2015/07/Fundi_4705Fsmb-800x1000.jpg",
    },
    {
      name: "Sullivan Key (test)",
      position: "App Tester",
      access: "guest",
      pic:
        "https://www.bethesdaheadshots.com/wp-content/uploads/2015/04/Stuart_7028L-800x1000.jpg",
    },
    {
      name: "Dalibor Böhler (test)",
      position: "Physician",
      access: "admin",
      pic:
        "https://www.bethesdaheadshots.com/wp-content/uploads/2022/10/LINDSAY-KOUYATE_5852-800x1000-1.jpg",
    },
    {
      name: "Shobha Perreault (test)",
      position: "Healthcare VA",
      access: "member",
      pic:
        "https://www.bethesdaheadshots.com/wp-content/uploads/2022/05/rockville-md_headshot-photographer-8114-800o.jpeg",
    },
    {
      name: "Liudmila Wirner (test)",
      position: "App Tester",
      access: "guest",
      pic:
        "https://www.bethesdaheadshots.com/wp-content/uploads/2021/06/JONATHAN_5022P_ppFIN.jpg",
    },
    {
      name: "Carlota Sulit (test)",
      position: "Physician",
      access: "member",
      pic:
        "https://images.squarespace-cdn.com/content/v1/5cf0d08d5fc69d000172462a/1599805610146-J0G5GMGFBXVWND4Z71UK/Aleem+Business+Headshot+for+LinkedIn+Profile.jpg",
    },
    {
      name: "Rose Reyes (test)",
      position: "Healthcare VA",
      access: "admin",
      pic:
        "https://images.squarespace-cdn.com/content/v1/5cf0d08d5fc69d000172462a/1636100249202-5NY98C6ASRIFFPO9GZTU/Tom+Professional+Business+Headshot.jpg?format=500w",
    },
    {
      name: "Shobha Perreault (test)",
      position: "Healthcare VA",
      access: "admin",
      pic:
        "https://www.bethesdaheadshots.com/wp-content/uploads/2022/05/rockville-md_headshot-photographer-8114-800o.jpeg",
    },
  ];
  const city = [
    {
      name: "Muskogee (US)",
      objectId: 1,
    },{
      name: "Windsor (CA)",
      objectId: 2,
    },{
      name: "Barre (US)",
      objectId: 3,
    },
  ];
  const state = [
    {
      name: "Arizona",
    },{
      name: "Hawaii",
    },{
      name: "Oregon",
    },
  ];
  const country = [
    {
      name: "Mexico",
    },{
      name: "Cabo Verde",
    },{
      name: "Belarus",
    },
  ];
  const orgRole = [
    "Prescriber",
    "Editor",
    "None"
  ];

  return {
    testMembers:testMembers,
    city:city,
    state:state,
    country:country,
    orgRole:orgRole
  };
};

export default UseTestMembers;
